import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'
import { AuthService } from './auth'

const withCompanyQuery = (url, queryParams = {}, { includeCompanyId = true } = {}) => {
    const companyId = AuthService.getUser()?.CompanyId
    const params = { ...queryParams }
    if (includeCompanyId && companyId) {
        params.companyId = companyId
    }
    const qs = CommonUtility.objectToParams(params)
    return qs ? `${url}?${qs}` : url
}

class ConsolidatedReportSchedule {
    list(queryParams = {}) {
        return BaseService.get(
            withCompanyQuery(APIPath.consolidatedReportSchedule, queryParams),
        )
    }

    get(id, queryParams = {}) {
        return BaseService.get(
            withCompanyQuery(APIPath.consolidatedReportScheduleById(id), queryParams),
        )
    }

    add(data) {
        return BaseService.postExact(
            withCompanyQuery(
                APIPath.consolidatedReportSchedule,
                {},
                { includeCompanyId: false },
            ),
            data,
        )
    }

    update(id, data) {
        return BaseService.put(
            withCompanyQuery(APIPath.consolidatedReportScheduleById(id)),
            data,
        )
    }

    remove(id) {
        return BaseService.remove(APIPath.consolidatedReportScheduleById(id))
    }

    hold(id, onHold) {
        return BaseService.postExact(
            APIPath.consolidatedReportScheduleHold(id),
            { OnHold: onHold },
        )
    }

    testSend(id) {
        return BaseService.postExact(
            APIPath.consolidatedReportScheduleTestSend(id),
            {},
        )
    }

    fireNow(id, reasonText) {
        return BaseService.postExact(
            APIPath.consolidatedReportScheduleFireNow(id),
            {
                Confirm: true,
                ReasonText: reasonText,
            },
        )
    }

    getColumns(id) {
        return BaseService.get(APIPath.consolidatedReportScheduleColumns(id))
    }

    /** Audits per template in the caller's company over the last N days (sorts the template picker). */
    templateUsage(days = 30) {
        return BaseService.get(APIPath.consolidatedReportTemplateUsage(days))
    }

    saveColumns(scheduleId, columns) {
        return BaseService.postExact(APIPath.consolidatedReportScheduleColumnsSave, {
            ScheduleId: Number(scheduleId),
            Columns: columns,
        })
    }

    listRuns(queryParams = {}) {
        return BaseService.get(
            withCompanyQuery(APIPath.consolidatedReportScheduleRuns, queryParams),
        )
    }

    getRunHistory(id, queryParams = {}) {
        return BaseService.get(
            withCompanyQuery(
                APIPath.consolidatedReportScheduleRunHistory(id),
                queryParams,
            ),
        )
    }
}

const ConsolidatedReportScheduleService = new ConsolidatedReportSchedule()
Object.freeze(ConsolidatedReportScheduleService)
export { ConsolidatedReportScheduleService }
